module.exports = __webpack_public_path__ + "img/av_peacock.bcef575d.png";